<!-- 新建/编辑费用明细管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="费用明细名称" prop="name">
              <div class="list-img-box">
                <el-input placeholder="请输入费用明细名称" v-model="formValidate.name"></el-input>
              </div>
            </el-form-item>
            <!--<el-form-item label="价格" prop="price">
              <div class="list-img-box">
                <el-input placeholder="请输入价格" v-model="formValidate.price"></el-input>
              </div>
            </el-form-item>-->
            <el-form-item label="费用明细详情" prop="introduction">
              <div class="list-img-box">
                <el-input type="textarea"  placeholder="请输入费用明细详情" v-model="formValidate.introduction"></el-input>
              </div>
            </el-form-item>
          </el-form>
          <!-- 保存 -->
          <div :style="{textAlign:'center'}">
            <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
            <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'CostManagementOperation',
    data () {
      return {
        formValidate: {
          name: '',//添加地标名称
          price: '',//价格
          introduction: '',//详情
        },
        ruleValidate: { //学校非空验证
          name: [
            { required: true, message: '请输入费用明细名称', trigger: 'blur'}
          ]
        },
      }
    },
    methods: {
      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
            if (valid) {
              let params = {},title="新增";
              if (this.$route.query.data == undefined){
                params = {
                  name:this.formValidate.name,
                  price:this.formValidate.price,
                  introduction:this.formValidate.introduction,
                  status:1
                }
                this.$route.query.tableData.push(params);
              } else {
                params = {
                  id:this.$route.query.data.id,
                  name:this.formValidate.name,
                  price:this.formValidate.price,
                  introduction:this.formValidate.introduction,
                  status:1
                }
                for (let i = 0; i < this.$route.query.tableData.length; i++){
                  if(this.$route.query.tableData[i].id == this.$route.query.data.id){
                    this.$route.query.tableData[i] = params;
                  }
                }
                title = "编辑";
              }
              this.$api.saveOrUpdateCostAssistantBatch({parameter: JSON.stringify(this.$route.query.tableData)}).then(res => {
                if (res.data.status == 200) {
                  this.$message({
                    type: 'success',
                    message: title+'成功！'
                  });
                  this.$router.push('/CostManagement');
                } else {
                  this.$message({
                    type: 'error',
                    message: res.data.message
                  });
                }
              });
            }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/CostManagement');
      }
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.name = this.$route.query.data.name;
        this.formValidate.price = this.$route.query.data.price;
        this.formValidate.introduction = this.$route.query.data.introduction;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/CostManagementOperation.vue